import React from 'react';
import { create, InstanceProps } from 'react-modal-promise';

import { IconButton } from 'components';
import Modal from 'components/Modal';
import { FLAG_STATUS_CODES } from 'hooks/useCandidate';
import ApplyConfirmation from '../ApplyConfirmation';

import styles from './ApplyConfirmationModal.module.scss';

interface ModalInstanceProps {
  isEvent: boolean;
}

const ModalInstance: React.FC<
  ModalInstanceProps & InstanceProps<FLAG_STATUS_CODES>
> = ({ isOpen, onResolve, onReject, isEvent }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onReject}
    contentClassName={styles.container}
    className={styles.applyModal}
  >
    <IconButton
      size="xsmall"
      iconName="close"
      className={styles.cancelIcon}
      onClick={() => onReject()}
    />
    <ApplyConfirmation
      onComplete={onResolve}
      onCancel={onReject}
      className={styles.content}
      isEvent={isEvent}
    />
  </Modal>
);

export const applyConfirmationModalInstance = create(ModalInstance);
